<div id="distinctive" class="watermark">
  <div class="container-fluid px-lg-5">
    <div class="row">
      <div class="col-12">
        <h2 class="title">Institutional Distinctiveness</h2>

        <p class="inner-lead mt-3">
          As enshrined in our vision,
          <strong>empowerment of women from rural and suburban society in all aspects is the distinctive feature of our institution.</strong>
          Since most of our students are from economically and socially backward circumstances, we support them to
          overcome their adversities and achieve their goals and transform them into ideal individuals of the society.
        </p>

        <p class="inner-lead">
          Various curricular and co-curricular activities that ensure social, academic, economic, artistic, spiritual and emotional
          enhancement of the students are conducted by our institution through clubs, cells and associations to achieve the goal
          of women empowerment i.e.
          <strong>
            Social Empowerment of Students – For Strengthening Social Responsibilities, Personality Development and
            Improving the Perception of Social Equity and Gender Equity.
          </strong>
        </p>

        <h5 class="mt-4 mb-3 fw-bold">
          Various Cells/Clubs/Associations/Activities/Programs
        </h5>

        <ul class="inner-lead">
          <li>Women Cell</li>
          <li>Scouts and Guides</li>
          <li>Seminars and Lectures on Women Empowerment</li>
          <li>Awareness Classes</li>
          <li>Self-Employment Trainings</li>
          <li>Innovative Workshops</li>
          <li>Manuscript Magazines</li>
          <li>Interdepartmental Competitions</li>
          <li>Youth Red Cross/Red Ribbon Club</li>
          <li>Seminars and Awareness Talks</li>
          <li>Blood Donation Camps</li>
          <li>Internal Grievance Cell</li>
          <li>Confidential Fetching of Complaints through Complaint Boxes</li>
          <li>Addressing and Resolving of Academic and Non-academic Grievances of Students</li>
          <li>Mentoring and Tutorial System</li>
          <li>Personal Mentor and Tutor for each Student</li>
          <li>Building close relationships among Teachers, Students and Parents</li>
          <li>Helps Students in Stress Management</li>
          <li>Value Education Classes</li>
          <li>Inculcates Students with Essential Social Values</li>
          <li>Imparting the significance of tolerance and respect towards cultural diversities</li>
          <li>Empowerment of Human Rights – For creating awareness among students about their individual rights</li>
          <li>Anti-Ragging Cell</li>
          <li>Awareness Classes</li>
          <li>Appropriate actions against ragging complaints</li>
          <li>Anti-Drug Forum</li>
          <li>Awareness Classes</li>
          <li>Anti-Drug Awareness Seminars</li>
          <li>Awareness Rallies</li>
          <li>Awareness Campaigns</li>
          <li>Street Plays</li>
          <li>Organizing Competitions for Awareness against Drug Abuse</li>
          <li>Observation of International Day against Drug Abuse and Illicit Trafficking</li>
          <li>Participation in Intercollegiate Competitions against Drug Abuse</li>
          <li>Anti-Sexual Harassment Cell</li>
          <li>Ensuring Security and Safety of Students</li>
          <li>Equal Opportunity Cell</li>
          <li>Ensuring Equality Among Students</li>
          <li>SC/ST, OBC and Minority Cells</li>
          <li>Ensuring awareness of Central and State Scholarships and Benefits</li>
          <li>Ensuring Wellness of Students and Prevention of Discrimination</li>
          <li>NSS, NCC and Departmental Associations</li>
          <li>Observance of Specific Days</li>
          <li>Environmental Awareness Programs</li>
          <li>Beyond the Campus Activities</li>
          <li>Flood Relief Activities</li>
          <li>Training Programs</li>
          <li>Health and Hygiene Programs</li>
        </ul>
      </div>
    </div>
  </div>
</div>
